import { IsProdMode, IsTestMode } from "../../utils/AppSetting";

// Web API url
// export const APIURL = (IsProdMode) ? "http://testingimsapi.echemportal.net/api/" : "https://localhost:44378/api/";
// export const APIURL = (IsProdMode) ? "http://inquiriesapi.echemportal.net/api/" : "https://localhost:44378/api/";
// export const APIURL = (IsProdMode) ? "http://inquiriesapi.echemportal.net/api/" : "https://localhost:44321/api/";
export const SSOAPIURL = (IsProdMode) ? process.env.REACT_APP_SSOLIVEURL : (IsTestMode) ? process.env.REACT_APP_SSOTESTURL : process.env.REACT_APP_SSOLOCALURL;

export const APIURL = (IsProdMode) ? process.env.REACT_APP_LIVEURL : (IsTestMode) ? process.env.REACT_APP_TESTURL : process.env.REACT_APP_LOCALURL; // Testing

//User Service
export const AddUsers = "User/AddUsers"
export const UpdateUsers = "User/UpdateUsers"
export const DeleteUsers = "User/DeleteUsers";
export const GetUsersById = "User/GetUsersById?id={0}"
export const GetUsersByEmailAddress = "User/GetUsersByEmailAddress?emailAddress=''"
export const GetUsersList = "User/GetUsersList";
export const UpdateUserStatus = "User/UpdateUserStatus";

//Vendor Service
export const AddVendors = "Vendor/AddVendors"
export const UpdateVendors = "Vendor/UpdateVendors"
export const DeleteVendors = "Vendor/DeleteVendors";
export const GetVendorsById = "Vendor/GetVendorsById?id={0}"
export const GetVendorsList = "Vendor/GetVendorsList";
export const GetAllActiveVendors = "Vendor/GetAllActiveVendors";
export const GetAssignVendorsByGroupId = "Vendor/GetAssignVendorsByGroupId?id={0}";
export const GetUnAssignVendorsByGroupId = "Vendor/GetUnAssignVendorsByGroupId?id={0}";
export const AssingVendorsToGroup = "Vendor/AssingVendorsToGroup";
export const UnAssingGrouptoVendors = "Vendor/UnAssingGrouptoVendors";
export const GetActiveVendorsForEmail = "Vendor/GetActiveVendorsForEmail";
export const GetVendorGrabbersByVendorId = "Vendor/GetVendorGrabbersByVendorId?id={0}"
export const AddVendorGrabbers = "Vendor/AddVendorGrabbers"


//Email Template Services
export const AddEmailTemplates = "EmailTemplate/AddEmailTemplates";
export const UpdateEmailTemplates = "EmailTemplate/UpdateEmailTemplates"
export const DeleteEmailTemplates = "EmailTemplate/DeleteEmailTemplates";
export const GetEmailTemplatesList = "EmailTemplate/GetEmailTemplatesList";
export const GetEmailTemplateById = "EmailTemplate/GetEmailTemplateById?id={0}"
export const GetEmailTemplatesListByEmailTypeId = "EmailTemplate/GetEmailTemplatesListByEmailTypeId?id={0}"
export const GetEmailTypesList = "EmailTemplate/GetEmailTypesList";

//Account Service
// export const Login = "Account/Login";
export const AdminLogin = "Authentication/AdminLogin";
export const ResetPassword = "Account/ResetPassword";
export const ValidateToken = "Authentication/ValidateToken";
export const ProjectAuthentication = "Account/ProjectAuthentication";
export const GetUserDetailsByClientIdAndSecretkey = "Authentication/GetUserDetailsByClientIdAndSecretkey";

//EmailConfiguration Service
export const AddEmailConfigurations = "EmailConfiguration/AddEmailConfigurations";
export const UpdateEmailConfigurations = "EmailConfiguration/UpdateEmailConfigurations";
export const DeleteEmailConfigurations = "EmailConfiguration/DeleteEmailConfigurations";
export const GetEmailConfigurationsById = "EmailConfiguration/GetEmailConfigurationsById?id={0}";
export const GetEmailConfigurationsList = "EmailConfiguration/GetEmailConfigurationsList";

//Product Service
export const AddProducts = "Product/AddProducts";
export const UpdateProducts = "Product/UpdateProducts";
export const DeleteProducts = "Product/DeleteProducts";
export const GetProductsById = "Product/GetProductsById?id={0}";
export const GetProductsList = "Product/GetProductsList";

// Inquiry Product Services
export const AddInquiryProducts = "InquiryProductDetail/AddInquiryProducts";
export const UpdateInquiryProductDetails = "InquiryProductDetail/UpdateInquiryProductDetails";

export const UpdateInquiryProductsStatus = "InquiryProductDetail/UpdateInquiryProductsStatus";
export const DeleteInquiryProducts = "InquiryProductDetail/DeleteInquiryProducts";
export const GetInquiryProductsList = "InquiryProductDetail/GetInquiryProductsList";
export const GetInquiryProductsById = "InquiryProductDetail/GetInquiryProductsById?id={0}";
export const GetProductIdForMapProduct = "InquiryProductDetail/GetProductIdForMapProduct";
export const UpdateInquiryProductForMap = "InquiryProductDetail/UpdateInquiryProductForMap";


// Inquiry Prouduct Responce Services
export const AddInquiryProductResponses = "InquiryProductResponse/AddInquiryProductResponses";
export const UpdateInquiryProductResponses = "InquiryProductResponse/UpdateInquiryProductResponses";
export const DeleteInquiryProductResponses = "InquiryProductResponse/DeleteInquiryProductResponses";
export const GetInquiryProductResponsesList = "InquiryProductResponse/GetInquiryProductResponsesList";
export const GetInquiryProductResponsesById = "InquiryProductResponse/GetInquiryProductResponsesById";

// Inquiry Email Services
export const AddInquiryEmails = "InquiryEmail/AddInquiryEmails";
export const UpdateInquiryEmails = "InquiryEmail/UpdateInquiryEmails";
export const DeleteInquiryEmails = "InquiryEmail/DeleteInquiryEmails";
export const GetInquiryEmailsList = "InquiryEmail/GetInquiryEmailsList";
export const GetInquiryEmailsById = "InquiryEmail/GetInquiryEmailsById?id={0}";
export const SendInquiryEmails = "InquiryEmail/SendInquiryEmails";
export const GetProductInquiryEmailDetail = "InquiryEmail/GetProductInquiryEmailDetail";
export const GetInquiryHistoriesList = "InquiryEmail/GetInquiryHistoriesList";
export const GetInquiryResponseListByInquiryEmailId = "InquiryEmail/GetInquiryResponseListByInquiryEmailId";
export const GetInquiryRequestConutById = "InquiryEmail/GetInquiryRequestConutById?id={0}";
export const GetInquiryResponseListForUnmapped = "InquiryEmail/GetInquiryResponseListForUnmapped";
export const GetInquiredProductDetails = "InquiryEmail/GetInquiredProductDetails?id={0}";
export const GetInquiryEmailsListForUnmapped = "InquiryEmail/GetInquiryEmailsListForUnmapped";
export const UpdateInquiryResponse = "InquiryEmail/UpdateInquiryResponse";
export const GetInquiryEmailsHistory = "InquiryEmail/GetInquiryEmailsHistory";
export const AddReasonForInquiry = "InquiryEmail/AddReasonForInquiry";
export const DeleteUnmappedResponseEmail = "InquiryEmail/DeleteUnmappedResponseEmail";
export const GetAllUnmappedDeletedEmailsList = "InquiryEmail/GetAllUnmappedDeletedEmailsList";


//Vendor Group Service
export const AddVendorGroups = "VendorGroup/AddVendorGroups"
export const UpdateVendorGroups = "VendorGroup/UpdateVendorGroups"
export const DeleteVendorGroups = "VendorGroup/DeleteVendorGroups";
export const GetVendorGroupsById = "VendorGroup/GetVendorGroupsById?id={0}"
export const GetVendorGroupsList = "VendorGroup/GetVendorGroupsList";

//Vendor Preferences Services
export const AddVendorPreferences = "VendorPreference/AddVendorPreferences";
export const GetUnAssignVendorsPreference = "VendorPreference/GetUnAssignVendorsPreference";
export const GetAllAssignVendorsForMandate = "VendorPreference/GetAllAssignVendorsForMandate";
export const GetAllAssignVendorsForBlock = "VendorPreference/GetAllAssignVendorsForBlock";
export const GetAllMandateVendorsEmailAddress = "VendorPreference/GetAllMandateVendorsEmailAddress";

// Inquiry Response Services
export const DeleteInquiryResponse = "InquiryResponse/DeleteInquiryResponse";
export const GetInquiryResponseList = "InquiryResponse/GetInquiryResponseList";
export const GetInquiryResponseById = "InquiryResponse/GetInquiryResponseById?id={0}";
export const SendInquiryResponseEmails = "InquiryResponse/SendInquiryResponseEmails";
export const GetInquiryProductDetailByEmailId = "InquiryResponse/GetInquiryProductDetailByEmailId?id={0}";

//Email Attachment Services
export const AddEmailAttachments = "EmailAttachment/AddEmailAttachments";
export const GetEmailAttachmentsByKeyFieldAndValue = "EmailAttachment/GetEmailAttachmentsByKeyFieldAndValue";
export const DeleteEmailAttachments = "EmailAttachment/DeleteEmailAttachments";

//Email Grabber Response Services
export const GetEmailGrabberResponseByInquiryId = "EmailGrabberResponse/GetEmailGrabberResponseByInquiryId?id={0}"

//Email Grabber Request Services
export const GetEmailGrabberRequestsByInquiryId = "EmailGrabberRequest/GetEmailGrabberRequestsByInquiryId?id={0}"
export const UpdateEmailGrabberRequest = "EmailGrabberRequest/UpdateEmailGrabberRequest"


//Inquiry Response Product Quantity Services
export const AddInquiryResponseProductQuantities = "InquiryResponseProductQuantities/AddInquiryResponseProductQuantities";
export const UpdateInquiryResponseProductQuantities = "InquiryResponseProductQuantities/UpdateInquiryResponseProductQuantities";
export const DeleteInquiryResponseProductQuantitiesById = "InquiryResponseProductQuantities/DeleteInquiryResponseProductQuantitiesById";

//Inquiry Response Product Detail Services
export const UpdatePurityInquiryResponse = "InquiryResponseProductDetail/UpdatePurityInquiryResponse";

//Master Vendors Services
export const GetMasterVendorsList = "MasterVendor/GetMasterVendorsList";
export const GetMasterVendorsById = "MasterVendor/GetMasterVendorsById?id={0}";
export const GetSimilarVendorListByMapVendorId = "MasterVendor/GetSimilarVendorListByMapVendorId";
export const UpdateMasterVendors = "MasterVendor/UpdateMasterVendors";
export const DeleteMasterVendors = "MasterVendor/DeleteMasterVendors";
export const GetDeletedMasterVendorsList = "MasterVendor/GetDeletedMasterVendorsList";


//SetSystemConfiguration Services  
export const SetSystemConfiguration = "SystemConfiguration/SetSystemConfiguration";
export const GetSystemConfiguration = "SystemConfiguration/GetSystemConfiguration";

//Inquiry Logs
export const GetEmailGrabberLogById = "EmailGrabberRequest/GetEmailGrabberLogById?id={0}"
